window.removeSelectedFilters = function() {
    let selectedFilters = document.querySelectorAll('.c-checkbox:checked, .custom-checkbox:checked');

    selectedFilters.forEach((filter) => {
        filter.checked = false;
    });
}

window.App.CategoryThreeActivator = function (id) {
    let categoryNode = document.querySelector('.dropdown--category');

    let activeItem = categoryNode.querySelector('[data-product-category="' + id +'"]');
    if(activeItem) {
        activeItem.classList.add('active');

        let node = activeItem;
        while(node !== categoryNode) {
            node = node.parentElement;
            if(node.classList.contains('dropdown__content')) {
                node.classList.add('opened');

                node.parentElement.querySelector('.dropdown__button').classList.add('opened');
            }
        }
    }

    if(categoryNode.dataset.filters) {
        let allLinks = categoryNode.querySelectorAll('a');
        allLinks.forEach(link => {
           if(link.getAttribute('href').toString().indexOf('?') !== -1) {
               let url = link.getAttribute('href') + '&' + categoryNode.dataset.filters;
               link.setAttribute('href', url);
           }
           else {
               let url = link.getAttribute('href') + '?' + categoryNode.dataset.filters;
               link.setAttribute('href', url);
           }
        });
    }
}